import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Typography,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import moment from "moment";

const CashFlowReportTableFilter = (props) => {
  const [form] = Form.useForm();

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: false,
  });

  const [selectedCurrency, setSelectedCurrency] = useState(null);

  useEffect(() => {
    getCurrencies();
  }, []);

  useEffect(() => {
    // props.monthly true -> monthly_, false -> daily_
    const prefix = props.monthly ? "monthly_" : "daily_";
    const params = new URLSearchParams(window.location.search);

    // Sadece kendi prefix'ine ait paramları oku
    const filteredData = {};
    params.forEach((val, key) => {
      if (key.startsWith(prefix)) {
        filteredData[key.replace(prefix, "")] = val;
      }
    });

    // props.data varsa, URL'deki prefixli verilerle birleştir
    const data =
      Object.keys(filteredData).length > 0 ? filteredData : props.data || {};

    if (data.currencyCode) {
      RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
        setCurrencySelect({
          data: response,
          loading: false,
        });

        const selected = response.find(
          (item) => item.value === data.currencyCode
        );
        setSelectedCurrency(selected);

        form.setFieldsValue({
          currencyId: selected?.id ?? data.currencyId,
        });
      });
    }

    if (data.startDate != undefined) {
      form.setFieldsValue({
        dateRange: [moment(data.startDate), moment(data.endDate)],
      });
    }
  }, [props.data, props.monthly]);

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });

    RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
      setCurrencySelect({
        data: response,
        loading: false,
      });
    });
  };

  const onFinish = (values) => {
    {
      let query = {};

      query.currencyId = values.currencyId ? values.currencyId : null;
      query.currencyCode = currencySelect.data.find(
        (item) => item.id === values?.currencyId
      )
        ? currencySelect.data.find((item) => item.id === values?.currencyId)
            ?.value
        : "TRY";

      if (values.dateRange) {
        const [startDate, endDate] = values.dateRange;

        query.startDate = startDate.format("MM/DD/YYYY");
        query.endDate = endDate.format("MM/DD/YYYY");
      } else {
        query.startDate = null;
        query.endDate = null;
      }
      values = {
        ...values,
        startDate: query.startDate,
        endDate: query.endDate,
        currencyCode: query.currencyCode,
      };

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel
            header="Filtreleme için tıklayınız."
            extra={
              props.extraText ? (
                <Typography>
                  <Typography.Paragraph
                    style={{
                      marginBottom: 0,
                      fontSize: "80%",
                    }}
                    type="secondary"
                  >
                    {props.extraText}
                  </Typography.Paragraph>
                </Typography>
              ) : null
            }
          >
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="dateRange" label="Tarih :">
                    <DatePicker.RangePicker
                      picker={props.monthly ? "month" : "date"}
                      format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={currencySelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      value={selectedCurrency ? selectedCurrency.id : undefined}
                    >
                      {currencySelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default CashFlowReportTableFilter;
